import { transformSheetPoint } from "@local/extensions/geometry/transform-sheet-points.js";

function normalizeAngle(angle = 0) {
  return ((angle % 360) + 360) % 360;
}

function tileSize(w, h, sr) {
  if ([90, 270].includes(sr)) {
    return {
      x: h,
      y: w,
    };
  }

  return {
    x: w,
    y: h,
  };
}

function linkPosition(dest, sheet) {
  if (!dest || !sheet) {
    return null;
  }

  const [xmin, ymin] = sheet.limits[0];
  const [xmax, ymax] = sheet.limits[1];

  const width = xmax - xmin;
  const height = ymax - ymin;
  const rotation = normalizeAngle(sheet.rotation);
  const ts = tileSize(width, height, rotation);

  let left, top, right, bottom;
  switch (dest.position) {
    case "XYZ":
      left = dest.params[0];
      top = dest.params[1];
      const zoom = dest.params[2] || 1;
      const w = (xmax - xmin) / zoom;
      const h = (ymax - ymin) / zoom;
      right = left + w;
      bottom = top - h;
      break;
    case "Fit":
    case "FitB":
      left = xmin;
      top = ymin;
      right = xmax;
      bottom = ymax;
      break;
    case "FitH":
    case "FitBH":
      left = xmin;
      right = xmax;
      top = dest.params[0];
      bottom = ymax;
      break;
    case "FitV":
    case "FitBV":
      top = ymin;
      bottom = ymax;
      left = dest.params[0];
      right = xmax;
      break;
    case "FitR":
      left = dest.params[0];
      bottom = dest.params[1];
      right = dest.params[2];
      top = dest.params[3];
      break;
  }

  const a = transformSheetPoint({ x: left, y: top }, rotation, 1, ts);
  const b = transformSheetPoint({ x: right, y: bottom }, rotation, 1, ts);

  const x1 = Math.min(a.x, b.x);
  const y1 = Math.min(-a.y, -b.y);
  const x2 = Math.max(a.x, b.x);
  const y2 = Math.max(-a.y, -b.y);

  return { x: x1, y: y1, width: x2 - x1, height: y2 - y1 };
}

export default linkPosition;
